import { Farm } from 'src/domain/farm'
import { FarmConfig } from 'src/domain/farm'
import { FarmDto, CreateFarmDTO, UpdateFarmDTO, FarmConfigDto, CreateFarmConfigDTO } from 'src/dto/farm.dto'
import { FarmService } from 'src/services/api/farm.service'

export class FarmController {
  private service: FarmService

  constructor() {
    this.service = new FarmService()
  }

  public async getFarmList(username: string): Promise<FarmDto[]> {
    const response = await this.service.getFarmList(username)
    return response.data
  }

  public async getAllFarms(): Promise<FarmDto[]> {
    const response = await this.service.getAllFarms()
    return response.data
  }

  public async createFarm(baseFarmId: string, payload: CreateFarmDTO): Promise<FarmDto> {
    const farmParse = new Farm(payload)
    const configParse = new FarmConfig({
      idFazenda: farmParse.idFazenda
    })
    const response = await this.service.createFarm(baseFarmId, {
      ...farmParse,
      configuracao: configParse
    })
    return response.data
  }

  public async updateFarm(baseFarmId: string, payload: UpdateFarmDTO): Promise<FarmDto> {
    const farmParse = new Farm(payload)
    const response = await this.service.updateFarm(baseFarmId, farmParse)
    return response.data
  }

  public async createFarmConfig(payload: CreateFarmConfigDTO): Promise<FarmConfigDto> {
    const farmConfigParse = new FarmConfig(payload)
    const response = await this.service.createFarmConfig(farmConfigParse)
    return response.data
  }
}
